import { useMutation, useQueryClient } from "react-query";

import { Move, Video } from "../../types";
import MoveService from "../../services/Move";

import { QUERY_KEY } from "./useListMoves";
import { makeQueryKey } from "./useFetchMove";

function useUpdateMove(onSuccess?: (move: Move) => void) {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      id,
      ...updates
    }: { id: Move["id"] } & Partial<Move> & { videos?: Video["id"][] }) =>
      MoveService.updateMove(id, updates),
    {
      onSuccess: (move, { id }) => {
        queryClient.invalidateQueries(QUERY_KEY);
        queryClient.setQueryData(makeQueryKey(id), move);

        onSuccess?.(move);
      },
    }
  );
}

export default useUpdateMove;
